var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdOrientation } from "../../constants/IdOrientation";
import { IdStyles } from "../../less/IdStyles";
import { selectChatInfo } from "../../selectors/selectChatInfo";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionChatPostInChatRoom, actionResetUnreadMessageCount } from "./actionChat";
import { ChatMessageSend } from "./ChatMessageSend";
import { ChatMessageView } from "./ChatMessageView";
var TabCoopChatDOM = /** @class */ (function (_super) {
    __extends(TabCoopChatDOM, _super);
    function TabCoopChatDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.handleScrollToBottomClick = function () {
            _this.setScrollToBottom();
        };
        props.onUnreadMessageCountReset();
        return _this;
    }
    TabCoopChatDOM.prototype.render = function () {
        var _this = this;
        var _a = this.props, chatInfo = _a.chatInfo, onMessagePost = _a.onMessagePost;
        return (React.createElement("div", { className: "flex flex--stacked flex__full h100 flex--around" },
            React.createElement("div", { className: "chat-messages" },
                React.createElement(ChatMessageView, { setScrollToBottom: function (scrollToBottom) {
                        return (_this.setScrollToBottom = scrollToBottom);
                    }, chatInfo: chatInfo })),
            React.createElement("div", { className: "chat-controls" },
                React.createElement(ChatMessageSend, { onMessageSend: onMessagePost }),
                React.createElement(ButtonHudNormal, { onClick: this.handleScrollToBottomClick },
                    React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconMedium, orientation: IdOrientation.Down })))));
    };
    return TabCoopChatDOM;
}(React.Component));
export var mapState = function (state) { return ({
    chatInfo: selectChatInfo(state),
}); };
export var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onMessagePost: actionChatPostInChatRoom,
        onUnreadMessageCountReset: actionResetUnreadMessageCount,
    }, dispatch);
};
export var TabCoopChat = connect(mapState, mapDispatch)(TabCoopChatDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/TabCoopChat.tsx
// module id = 2575
// module chunks = 3